
export enum GUID_ {
   E3E990DC900441ECB664E9043B9A77B7 /*serviceLayerClientIdHeaderName*/,
   E567D0E4603F4A7580212E770DE079AA /*serviceLayerClientId*/,
   F4D970E7D2214F33B390649AA5946C1E /*serviceLayerClientSecretHeaderName*/,
   D9A8BADB30FA4EDE975EAE987AABFBD4 /*serviceLayerClientSecret*/
}

export const guids = new Map<GUID_, string>([
   [GUID_.E3E990DC900441ECB664E9043B9A77B7, 'Client-Id-EE8289B486034E60'      /*serviceLayerClientIdHeaderName*/],
   [GUID_.F4D970E7D2214F33B390649AA5946C1E, 'Client-Secret-EE8289B486034E60'  /*serviceLayerClientSecretHeaderName*/]
])
